import localforage from "localforage";

type StoredItem<T> = {
  value: T;
  expiry: number;
};

const saveItemWithExpiry = async <T>(
  key: string,
  value: T,
  expiryInSeconds: number
): Promise<void> => {
  const item: StoredItem<T> = {
    value,
    expiry: new Date().getTime() + ((expiryInSeconds * 1000)),
  };

  await localforage.setItem(key, item);
};

const getItemWithExpiry = async <T>(key: string): Promise<T | null> => {
  const item: StoredItem<T> | null = await localforage.getItem(key);

  if (!item) {
    return null;
  }

  const currentTime = new Date().getTime();
  if (currentTime > item.expiry) {
    await localforage.removeItem(key);
    return null;
  }

  return item.value;
};

const isExpired = async (key: string): Promise<boolean> => {
    return await getItemWithExpiry(key) === null;
  };

const removeItem = async (key: string): Promise<void> => {
  await localforage.removeItem(key);
};

export default {
  saveItemWithExpiry,
  getItemWithExpiry,
  isExpired,
  removeItem,
};
